"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectToBPForm = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _addressForm = require("@ori/address-form");
var _commonFormFields = require("@ori/common-form-fields");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../../contexts");
var _models = require("../../../models");
var _api = require("../../../models/api");
var _utils = require("../../../utils");
var _FormValidationSummary = require("../../FormValidationSummary");
var _SponsorBox = require("./SponsorBox");
var _validationSchema = require("./validationSchema");
var _jsxRuntime = require("react/jsx-runtime");
var selectBpVariant = /*#__PURE__*/function (selectBpVariant) {
  selectBpVariant["findSponsor"] = "SponsorLocator";
  selectBpVariant["knowSponsorNumber"] = "ManualInput";
  return selectBpVariant;
}(selectBpVariant || {});
const StyledForm = (0, _mui.styled)('form')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  marginTop: theme.spacing(8)
}));
const SubmitButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(3)
}));
const FindButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  width: '330px',
  maxWidth: '100%',
  height: '35px',
  margin: '0 auto',
  marginBottom: theme.spacing(10)
}));
const BackButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: '60px',
  marginTop: theme.spacing(2)
}));
const StyledArrowIcon = (0, _mui.styled)(_icons.ArrowLeftThin)(({
  theme
}) => ({
  marginRight: theme.spacing(1)
}));
const StyledFormControlLabel = (0, _mui.styled)(_mui.FormControlLabel)(({
  theme
}) => ({
  alignItems: 'center',
  marginBottom: theme.spacing(3)
}));
const AddressAutocompleteWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginBottom: theme.spacing(6)
}));
const StyledToggle = (0, _mui.styled)(_components.Toggle)(({
  theme
}) => ({
  cursor: 'pointer'
}));
const StyledSingleLineLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(5)
}));
const ConnectToBPForm = props => {
  const {
    initialData,
    config,
    sponsorInfo,
    profileSponsorImage,
    isDefaultAddress,
    isSuccessSubmit,
    onSubmitForm
  } = props;
  const {
    stepperData
  } = (0, _contexts.useStepperData)();
  const {
    activeStep,
    setActiveStep,
    stepsOrder
  } = stepperData;
  const [rerenderKey, setRerenderKey] = (0, _react.useState)('');
  const defaultSelectSponsorType = config?.preselectedSponsorSelectionMethod ?? 'ManualInput';
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    setErrorData,
    customErrors
  } = errorData;
  const [selectSponsorType, setSelectSponsorType] = (0, _react.useState)(defaultSelectSponsorType);
  const [country, setCountry] = (0, _react.useState)(false);
  const [resetKey, setResetKey] = (0, _react.useState)(0);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const isKnowSponsorNumber = selectSponsorType === selectBpVariant.knowSponsorNumber;
  const isFindSponsorSelected = selectSponsorType === selectBpVariant.findSponsor;
  const validationSchema = (0, _validationSchema.useGetSchema)(config, isKnowSponsorNumber);
  const methods = (0, _reactHookForm.useForm)({
    defaultValues: initialData,
    reValidateMode: 'onChange',
    mode: 'all',
    resolver: (0, _zod.zodResolver)(validationSchema)
  });
  const {
    formState,
    watch,
    setValue
  } = methods;
  const {
    isValid,
    isSubmitting
  } = formState;
  const countryOptions = config?.address?.country?.availableOptions ?? [];
  const values = watch();
  const invalidCodeErrors = customErrors?.filter(er => !Object.keys(values).map(val => val.toLowerCase()).includes(er.fieldName?.toLowerCase() ?? ''));
  const countryFieldName = 'address.country';
  const {
    data: formatAddressFields
  } = (0, _api.useAddressFormatMetadata)('SingleLine');
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep
  } = virtualPageAnalyticsData;
  const handleChangeSponsorFindType = event => {
    setSelectSponsorType(event.target.value);
    setResetKey(Date.now());
    methods.reset(initialData);
    methods.clearErrors();
    setCountry(false);
    if (customErrors && customErrors.length > 0) {
      setErrorData([]);
    }
    setErrorData([]);
  };
  const handleBack = () => {
    setPreviousStep(stepsOrder[activeStep]);
    setActiveStep(activeStep - 1);
  };
  const handleNext = () => {
    setPreviousStep(stepsOrder[activeStep]);
    setActiveStep(activeStep + 1);
  };
  (0, _react.useEffect)(() => {
    if (values.address?.zipcode) {
      setSelectSponsorType(selectBpVariant.findSponsor);
    }
  }, [values.address?.zipcode]);
  (0, _react.useEffect)(() => {
    if (config?.address?.country?.isAvailable && selectSponsorType === selectBpVariant.findSponsor) {
      setValue(countryFieldName, countryOptions[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed other property
  }, [selectSponsorType]);
  const setAddressToForm = address => {
    Object.entries(address).forEach(([name, inputValue]) => {
      const options = inputValue?.toString() ? {
        shouldValidate: true,
        shouldDirty: true
      } : {};
      setValue(`address.${name}`, inputValue, options);
    });
    setRerenderKey('change values');
  };
  const formatedAddress = values.address?.zipcode ? (0, _utils.getOptionLabelSingleLine)(0, values.address, formatAddressFields ?? _utils.defaultAddressFormat) : null;
  const getAddressAutocomplete = () => {
    if (config?.address?.searchOptions?.isEnabled) {
      return /*#__PURE__*/(0, _react.createElement)(_addressForm.AddressAutoComplete, {
        ...config.address,
        key: rerenderKey,
        fields: formatedAddress ?? '',
        minSearchLength: 3,
        searchOptions: config.address.searchOptions,
        maxResults: config.address.searchOptions.maxResults,
        country: values?.address?.country,
        setAddressToForm: setAddressToForm
      });
    }
    return null;
  };
  const handleChangeCountry = countryProperty => {
    setCountry(countryProperty);
    if (typeof countryProperty === 'boolean') {
      if (countryProperty) {
        setValue(countryFieldName, countryOptions[1]);
      } else {
        setValue(countryFieldName, countryOptions[0]);
      }
    } else {
      setValue(countryFieldName, countryProperty);
    }
  };
  const getCountryField = () => {
    if (countryOptions.length === 2) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        mb: config?.address?.searchOptions?.isEnabled ? 5 : 0,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
          id: "country-select-sponsorForm",
          required: isFindSponsorSelected,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.SecondStep_Country,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Country
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledToggle, {
          fullWidth: true,
          checked: Boolean(country),
          firstText: countryOptions[0],
          secondText: countryOptions[1],
          onChange: ({
            currentTarget: {
              checked
            }
          }) => handleChangeCountry(checked)
        })]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.FormControl, {
      fullWidth: true,
      required: isFindSponsorSelected,
      sx: {
        marginBottom: config?.address?.searchOptions?.isEnabled ? 5 : 0
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
        id: "country-select-sponsorForm",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.SecondStep_Country,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Country
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Select
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
      , {
        value: country ? String(country) : undefined,
        fullWidth: true,
        labelId: "country-select-sponsorForm",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.SecondStep_Country,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Country
        }),
        onChange: e => handleChangeCountry(e.target.value),
        children: countryOptions.sort().map(opt => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
          value: opt,
          children: opt
        }, opt))
      })]
    });
  };
  const getCorrectSubmitButton = () => {
    if (isFindSponsorSelected) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitButtton, {
        variant: "contained",
        color: "primary",
        type: "button"
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        ,

        disabled: !sponsorInfo?.consultantNumber,
        onClick: () => handleNext(),
        ...getTestIdProps('submit-btn-sponsorForm'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.SecondStep_Button,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Button
        })
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitButtton, {
      variant: "contained",
      color: "primary",
      type: "submit",
      disabled: !isValid || isSubmitting || isSuccessSubmit,
      ...getTestIdProps('submit-btn-sponsorForm'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.SecondStep_Button,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Button
      })
    });
  };
  const addressAutocomplete = getAddressAutocomplete();
  const countryField = getCountryField();
  const noneSponsorLocator = !config?.address?.country?.isAvailable && !config?.address?.zipcode?.isAvailable;
  const isCountryOrZipcode = values.address?.country ?? values.address?.zipcode;
  const isDisabledFind = noneSponsorLocator ? false : !isCountryOrZipcode;
  const submitButton = getCorrectSubmitButton();
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  const knowSponsorLabelVariant = sponsorInfo?.consultantNumber ? 'body2' : 'body1';
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  const isSearchedAddressDisabled = !config?.address?.searchOptions?.isEnabled && !!formatedAddress?.length;
  const singleLineAddress = config?.address?.searchOptions?.isEnabled && formatedAddress ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSingleLineLabel, {
      variant: "caption",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.SecondStep_SearchedAddress,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_SearchedAddress
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body1",
      sx: {
        wordWrap: 'break-word'
      },
      children: formatedAddress
    })]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHookForm.FormProvider, {
    ...methods,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormValidationSummary.FormValidationSummary, {
      invalidPropertyErrors: invalidCodeErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledForm, {
      noValidate: true,
      onSubmit: methods.handleSubmit(onSubmitForm),
      children: [
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
      sponsorInfo?.consultantNumber ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SponsorBox.SponsorBox, {
        isVisibleNextButton: true,
        sponsorDetailInfo: sponsorInfo,
        sponsorImage: profileSponsorImage,
        title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.SecondStep_HeresYourBrandPartner,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_HeresYourBrandPartner
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
        container: true,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.RadioGroup, {
          name: "brand-partner",
          value: selectSponsorType,
          sx: {
            width: '100%'
          },
          onChange: handleChangeSponsorFindType,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
              component: "span",
              width: "100%",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFormControlLabel, {
                value: selectBpVariant.knowSponsorNumber,
                control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Radio, {
                  color: "primary"
                }),
                disabled: Boolean(sponsorInfo?.consultantNumber),
                label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
                  variant: knowSponsorLabelVariant,
                  sx: {
                    fontWeight: selectSponsorType === selectBpVariant.knowSponsorNumber ? 'bold' : 'normal'
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                    id: _models.TranslationKey.SecondStep_IKnowaBrandPartner,
                    defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_IKnowaBrandPartner
                  })
                })
              }), isKnowSponsorNumber ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
                inputType: "text",
                keyboardType: "numeric",
                name: "sponsorNumber",
                label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                  id: _models.TranslationKey.SecondStep_BrandPartnerNumber,
                  defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_BrandPartnerNumber
                }),
                ...config?.sponsorNumber,
                allowOnlyNumbers: true,
                isEditable: isKnowSponsorNumber,
                isMandatory: isKnowSponsorNumber,
                customErrors: customErrors
              }, resetKey) : null]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
              component: "span",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFormControlLabel, {
                value: selectBpVariant.findSponsor,
                control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Radio, {
                  color: "primary"
                }),
                label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
                  variant: "body1",
                  sx: {
                    fontWeight: selectSponsorType === selectBpVariant.findSponsor ? 'bold' : 'normal'
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                    id: _models.TranslationKey.SecondStep_FindTheBestBrandPartner,
                    defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_FindTheBestBrandPartner
                  })
                }),
                style: {
                  order: 0
                }
              }),
              // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
              isFindSponsorSelected && !sponsorInfo?.consultantNumber ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [config?.address?.country?.isAvailable && !isDefaultAddress ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  ...getTestIdProps('country-select-sponsorForm'),
                  children: countryField
                }) : null, initialData?.address?.zipcode ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(AddressAutocompleteWrapper, {
                    style: {
                      order: config?.address?.searchOptions?.displayOrder
                    },
                    children: [addressAutocomplete, isSearchedAddressDisabled ? singleLineAddress : null]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
                    name: "address.zipcode",
                    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.SecondStep_YourZipCode,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_YourZipCode
                    }),
                    helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.SecondStep_YourZipCode_Tooltip,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_YourZipCode_Tooltip
                    }),
                    ...config?.address?.zipcode,
                    isAddressMatchRequired: true,
                    maxLengthLimit: config?.address?.zipcode?.validation?.maxLength,
                    isMandatory: isFindSponsorSelected,
                    customErrors: customErrors
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FindButtton
                // this number is count of all possible inputs for address + 1 because we want as last
                , {
                  style: {
                    order: 16
                  },
                  variant: "contained",
                  color: "primary",
                  type: "submit",
                  disabled: isDisabledFind || isSubmitting || isSuccessSubmit,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                    id: _models.TranslationKey.SecondStep_Button_Find,
                    defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Button_Find
                  })
                })]
              }) : null,
              // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
              sponsorInfo?.consultantNumber ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  order: 16
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SponsorBox.SponsorBox, {
                  sponsorDetailInfo: sponsorInfo,
                  sponsorImage: profileSponsorImage,
                  title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                    id: _models.TranslationKey.SecondStep_HeresYourBrandPartner,
                    defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_HeresYourBrandPartner
                  }),
                  isVisibleNextButton: false
                })
              }) : null]
            })]
          })
        }), submitButton]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(BackButtton, {
        variant: "text",
        onClick: () => handleBack(),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledArrowIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.back,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.back
        })]
      })]
    })]
  });
};
exports.ConnectToBPForm = ConnectToBPForm;